import React, { createContext, useState, useEffect, useRef } from 'react';

const LocalContext = createContext();

function LocalContextProvider(props) {
  const [browserTabIsActive, setBrowserTabIsActive] = useState(true);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showMagicLinkDialog, setShowMagicLinkDialog] = useState(false);

  const dialogAnimationTime = 300;

  const loginDialogRef = useRef(null);
  const magicLinkDialogRef = useRef(null);

  const handleBrowserTabActivity = (forcedFlag) => {
    if (typeof forcedFlag === 'boolean') {
      return forcedFlag
        ? setBrowserTabIsActive(true)
        : setBrowserTabIsActive(false);
    }
    return document.hidden
      ? setBrowserTabIsActive(false)
      : setBrowserTabIsActive(true);
  };

  useEffect(() => {
    const handleBrowserTabActivityFalse = () => handleBrowserTabActivity(false);
    const handleBrowserTabActivityTrue = () => handleBrowserTabActivity(true);

    document.addEventListener('visibilitychange', handleBrowserTabActivity);
    document.addEventListener('blur', handleBrowserTabActivityFalse);
    window.addEventListener('blur', handleBrowserTabActivityFalse);
    window.addEventListener('focus', handleBrowserTabActivityTrue);
    document.addEventListener('focus', handleBrowserTabActivityTrue);

    return () => {
      window.removeEventListener('blur', handleBrowserTabActivity);
      document.removeEventListener('blur', handleBrowserTabActivityFalse);
      window.removeEventListener('focus', handleBrowserTabActivityFalse);
      document.removeEventListener('focus', handleBrowserTabActivityTrue);
      document.removeEventListener(
        'visibilitychange',
        handleBrowserTabActivityTrue
      );
    };
  }, []);

  const handleDialog = ({ dialogRef, animation, stateHandler, callback }) => {
    dialogRef.current.setAttribute('data-state', animation);
    dialogRef.current.children[0].setAttribute('data-state', animation);

    stateHandler();

    if (callback) {
      setTimeout(() => callback(), dialogAnimationTime);
    }
  };

  return (
    <LocalContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        browserTabIsActive,
        dialogAnimationTime,
        showLoginDialog,
        setShowLoginDialog,
        loginDialogRef,
        showMagicLinkDialog,
        setShowMagicLinkDialog,
        magicLinkDialogRef,
        handleDialog
      }}>
      {props.children}
    </LocalContext.Provider>
  );
}

export { LocalContextProvider };
export default LocalContext;
